import { getProductScope } from '@discover-frontend/utils';

import { API } from 'src/constants/config';
import ApiRequestHeader, {
  getAuthHeadersWithBearer,
} from 'src/utils/ApiRequestHeader';

/** Ensures every request URL carries the current product `scope` query param (deduped via URLSearchParams). */
const appendScopeQueryParam = (url: string) => {
  try {
    const parsed = new URL(url);
    parsed.searchParams.set('scope', String(getProductScope()));
    return parsed.href;
  } catch {
    return url;
  }
};

export const fetchWrapper_v2 = async (
  url: string,
  method = 'GET',
  body: any,
  withBearer = false
) => {
  const urlWithScope = appendScopeQueryParam(url);
  const authRequestHeader = withBearer
    ? getAuthHeadersWithBearer()
    : ApiRequestHeader();

  const isBodylessMethod = method === 'GET' || method === 'HEAD';

  const response = await fetch(urlWithScope, {
    headers: {
      ...authRequestHeader,
      Accept: 'application/json',
      ...(!isBodylessMethod ? { 'Content-Type': 'application/json' } : {}),
    },
    method,
    ...(isBodylessMethod ? {} : { body: JSON.stringify(body) }),
  });

  const res = await response.json();

  if (!response.ok || res.error) {
    throw new Error(res.message || 'Invalid request');
  }

  return { data: res || [], error: null };
};

export const callApi_v2 = (params) => {
  const { api = 'ACCOUNTS', method, endpoint, body } = params;

  const fullUrl = API[api].BASE_URL + endpoint;

  return fetchWrapper_v2(fullUrl, method, body);
};
